const filterItem = document.querySelectorAll('.js-filterItem');
const filterItemList = Array.prototype.slice.call(filterItem, 0);
const filterSelect = document.querySelector('.js-filterSelect');
let checkedFlag = false;
let selectedFlag = false;

window.addEventListener('DOMContentLoaded', () => {
  filterCheck();
});
filterAction(filterItemList);

function filterAction(filterItem) {
  filterItem.forEach((targetBox) => {
    targetBox.addEventListener('click', () => {
      if (targetBox.classList.contains('is-selected')) {
        targetBox.classList.remove('is-selected');
        if (targetBox.querySelector('input[type="checkbox"], input[type="radio"]')) {
          targetBox.querySelector('input').checked = false;
          filterCheck();
        }
      } else {
        for (let i = 0; i < filterItem.length; i++) {
          filterItem[i].classList.remove('is-selected');
          if (filterItem[i].querySelector('input[type="checkbox"], input[type="radio"]')) {
            filterItem[i].querySelector('input').checked = false;
            filterCheck();
          }
        }

        targetBox.classList.add('is-selected');
        if (targetBox.querySelector('input[type="checkbox"], input[type="radio"]')) {
          targetBox.querySelector('input').checked = true;
          filterCheck();
        }
      }
    });
  });

  filterSelect.addEventListener('change', () => {
    filterCheck();
  });
}

function filterCheck() {
  const filterSearch = document.querySelector('.js-filterSearch');

  if (document.querySelector('.js-filterItem.is-selected')) {
    checkedFlag = true;
  } else {
    checkedFlag = false;
  }

  if (filterSelect.value == 'none') {
    selectedFlag = false;
  } else {
    selectedFlag = true;
  }

  if (checkedFlag == false && selectedFlag == false) {
    filterSearch.classList.add('is-disabled');
  } else {
    filterSearch.classList.remove('is-disabled');
  }
}
